import { Constructor } from './constructor.type';
import { DynamicProperty } from '../decorators/dynamic-property.decorator';
import { IDynamicContext } from '../types/dynamic-context.interface';

export interface IDynamicContextMixin {
  context: IDynamicContext;
}
export type DynamicContextCtor = Constructor<IDynamicContextMixin>;

export function mixinDynamicContext<T extends Constructor<{}>>(base: T): DynamicContextCtor & T {
  class DynamicContextMixin extends base implements IDynamicContextMixin {
    @DynamicProperty({ displayName: 'Context', displayDescription: 'Component context' })
    context!: IDynamicContext;

    constructor(...args: any[]) {
      super(...args);
    }
  }

  return DynamicContextMixin;
}
